/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-25 21:40:02
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-20 14:39:44
 */
import Vue from 'vue';
import Router from 'vue-router';
import menus from '@/menus';
import store from '@/store';
import { generateRoutes } from '@/utils/permission';
import { normalRoutes, whiteList } from '@/utils/dataMap';
import * as types from '@/store/mutation-types';
import utils from '@/utils/common.js';
import { accountInfo } from '@/api/common';

Vue.use(Router);
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
};

const createRouter = () => {
	return new Router({
		mode: 'history',
		base: '/',
		routes: [...menus],
	});
};
// 生成vue-router对象
const router = createRouter();
export const resetRoute = router => {
	router.matcher = createRouter().matcher;
};
router.beforeEach(async (to, from, next) => {
	if (location.hostname == 'chaoyongtuan.com') {
		location.replace('https://www.chaoyongtuan.com/');
		return;
	}
	// 判断登录态
	if (!store.state.loginStatus) {
		// 非白名单页面都跳转登录页
		if (!whiteList.includes(to.path)) {
			return next('/login');
		}
		return next();
	}

	// 登录状态下访问登录页自动跳转首页
	if (to.path === '/login') {
		return next('/');
	}
	// 静态页面不需要权限校验
	if (normalRoutes.includes(to.path)) {
		return next();
	}
	// 过滤没有权限的菜单或者无需权限的页面
	if (!store.state.vuex_ready || !store.state.vuex_menuList.length) {
		store.commit(types.CHANGE_READY, true);
		// 获取字典数据
		await store.dispatch('loadDictDatas');
		// 设置权限信息
		await store.dispatch('setPermissionInfo');
		// 获取团队规则信息
		// await store.dispatch('GetCurrentRule');
		// 加载平台相关的类目
		await store.dispatch('setActCategoryList');
		// 从后端获取路由数据并进行加工
		// 确保字典及权限信息获取到之后再生成路由
		generateRoutes().then(async accessRoutes => {
			// 路由为空时清空数据返回登录页
			if (!accessRoutes.length) {
				Vue.prototype.$message.error('暂无权限，请联系管理员或咨询客服处理~');
				utils.clearData();
				if (to.path !== '/login') {
					return next('/login');
				}
			}
			// 根据roles权限生成可访问的路由表
			router.addRoutes(accessRoutes);
			// 将当前的路由表存储到vuex中
			store.commit(types.MEUNS_LIST, accessRoutes);
			// 切换角色loading关闭
			store.state.vuex_loading && store.state.vuex_loading.close();
			// 静态页面直接跳转
			if (whiteList.includes(to.path)) {
				return next({ ...to, replace: true });
			}
			// 租户下用户没有绑定微信跳转绑定页面
			const hasBindMiniPrograme = store.getters.accountInfo.openIds?.find(item => item.type == 32 && item.openId);
			if (!hasBindMiniPrograme) {
				return next('/bind');
			}
			// 获取php用户信息
			const { code, data } = await accountInfo({});
			if (code == 0) {
				// 更新配置字段
				store.commit(types.USER_INFO, data);
			}

			// 动态添加可访问路由表
			next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
		});
	} else if (!to.matched.length) {
		// 没有权限的页面直接跳转回工作台页面
		next('/');
	} else {
		next();
	}
});

router.afterEach(async to => {
	// 如果要访问的页面需要展示红点，并且该页面没有缓存到已访问过新功能的数组中，进行缓存
	if (to.meta.newFlag && !store.state.vuex_newFuncsViewed.includes(to.path)) {
		store.commit(types.NEW_FUNCS_VIEWED, to.path.split('?')[0]);
	}
	if (process.env.NODE_ENV == 'production') {
		await store.dispatch('checkVersion');
	}
});

export default router;
